import React from 'react'

import donationAmount from 'src/flp/donations/donationAmount'

const Donation = ({ order, config }) =>
  <div className="overlay p-2 rounded-3 d-flex align-items-end justify-content-between gap-2 donation">
    <div>
      <div className="h6 mb-0 fw-normal">
        <b className="d-block text-nowrap">
          {(config.show_full_name || order.has_business_name) ? order.donor_name : order.donor_name_and_initial}
        </b>
        <span className="text-slightly-muted" style={{ fontSize: '0.75em' }}>
          donated
        </span>
      </div>
    </div>
    {
      config.display_donation_amounts &&
      <div className="text-end amount-donated">
        <div className="h4 mb-0">
          <div className="amount">
            {donationAmount(order)}
          </div>
          <div
            className="text-slightly-muted fw-normal"
            style={{ fontSize: '0.5em' }}
          >{order.currency.iso_code}</div>
        </div>
      </div>
    }
  </div>

export default Donation
